import type { DomainType, ProjectBaseType, ProjectDetail } from '@core/core/types'
import { isCommonDomainType, isProjectType } from '@core/core/types'
import { ObjectEntries } from 'common/helpers'

import type { ProjectInfo as ApiProjectInfo } from '../__generated__/data-contracts'

export const convertProjectTypes = (from: Record<string, string>): ProjectBaseType[] =>
  ObjectEntries(from).reduce<ProjectBaseType[]>((arr, [key, value]) => {
    if (isProjectType(key)) {
      arr.push({ id: key, name: value })
    }
    return arr
  }, [])

export const convertDomainTypes = (from: Record<string, string>): DomainType[] =>
  ObjectEntries(from).reduce<DomainType[]>((arr, [key, value]) => {
    if (isCommonDomainType(key)) {
      arr.push({ id: key, name: value })
    }
    return arr
  }, [])

export const convertProjectInfo = (from: ApiProjectInfo): ProjectDetail => ({
  id: from.uid,
  name: from.name,
  type: from.type,
  year: from.year ?? new Date().getFullYear(),
  state: from.state,
  changedAt: from.changedAt?.toString(),
  companyId: from.companyUid,
  fieldId: from.fieldUid,
  createdBy: from.createdBy,
  // emoji of waiting
  size: String.fromCharCode(0x23f3),
})

export const convertProjectInfos = (from: ApiProjectInfo[]): ProjectDetail[] =>
  from.map<ProjectDetail>(convertProjectInfo)
